import { FaArrowRight } from "react-icons/fa";
import { useNavigateAndScroll } from "../../../hooks/useNavigateAndScroll";
import TwoSidesBox from "../../ui/two-sides-box/TwoSidesBox";
import WhatsappLink from "../../../utils/WhatsappLink";

export const Options = () => {
  const navigateAndScroll = useNavigateAndScroll();

  const baseURL = `${process.env.PUBLIC_URL}/assets/imagenes/about`;

  const side1 = {
    title: "¡Envianos un mensaje!",
    subtitle:
      "Solicitá una demo de nuestros productos sin costo con solo enviar un mensaje.",
    imageURL: baseURL + "/mail.png",
    button: {
      text: "Solicitar demo",
      onChange: () => navigateAndScroll("/demo", "form"),
      className: "boton-blanco",
    },
  };

  const side2 = {
    title: "Explorá nuestros productos",
    subtitle:
      "Descubrí cómo la inteligencia del cliente y la inteligencia de negocios pueden ayudarte a transformar tu empresa desde adentro.",
    imageURL: baseURL + "/productos.png",
    button: {
      text: "Explorar productos",
      onChange: () => navigateAndScroll("/business-intelligence", "top"),
      className: "boton-blanco",
      payload: (
        <WhatsappLink>
          <button className="boton-generico boton-blanco">
            <p>Más info</p>
            <FaArrowRight />
          </button>
        </WhatsappLink>
      ),
    },
  };

  return <TwoSidesBox side1={side1} side2={side2} />;
};
